<template>
  <div v-for="(audit, index) in auditsDataAfficher" v-bind:key="audit.cle" class="row ligne-audit-changement">
    <div class="col text-left">
      <div v-if="index === 0" class="row large-600">Enregistrement courant</div>
      <div v-for="field in AUDIT_FIELDS" v-bind:key="field" class="row">
        <div class="col-6">{{ FIELD_LABELS[field] }} :</div>
        <div class="col text-center">
          <div v-if="audit[field].isModifie">{{ this.MODIFIED_ARROW }}</div>
        </div>
        <div class="col">{{ audit[field].texte }}</div>
      </div>
      <div>
      <DataTable
          class="p-datatable-sm"
          :value="audit.justificationFichier"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          sortField="cle"
          :sortOrder="-1"
          responsiveLayout="scroll"
          :scrollableY="true"
          scrollHeight="500px"
          dataKey="cle"
      >
        <Column
            field="description"
            header="Description"
            :sortable="true"
            class="table-txt-wrap"
            @click="onSelect"
        >
          <template #body="slotProps">
            <label class="hyperlink underline" @click="onSelect(slotProps.data)">{{slotProps.data.description}}</label>
          </template>
        </Column>
        <Column
            field="creerPar"
            header="Créé Par"
            :sortable="true"
            class="table-txt-wrap"
        ></Column>
        <Column
            field="creerLe"
            header="Date de création"
            :sortable="true"
            class="table-txt-wrap"
        >
          <template #body="slotProps">
            {{
              $commun.formatDateHeure(
                  slotProps.data.creerLe
              )
            }}
          </template>
        </Column>
      </DataTable>
      </div>
      <div>----------------------------------------------------------------------------------------</div>
    </div>
  </div>

  <h3>Nombre de modifications : {{ nombreModifications }}</h3>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: "IntervenantTableModifications",
  emits: ["isDataLoaded", "backendError"],
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store
        .dispatch("pilotage/obtenirAuditIntervenantAction", {
          cle: this.$route.params.cle
        })
        .then((res) => {
          this.auditsData = res.data
          if (res.data !== null && res.data.length > 0) {
            this.auditsDataAfficher = this.formatterAudits(res.data)
          } else {
            this.auditsDataAfficher = this.formatterAucunAudit();
          }
        })
        .catch((err) => {
          this.$emit("backendError", err);
        })
        .finally(() => {
          this.$emit("isDataLoaded", true);
        })
  },
  data() {
    return {
      auditsData: [],
      auditsDataAfficher: [],
      justificationFichier: {},
      MODIFIED_ARROW: "🢂",
      //FIXME: ajouter les champs à afficher, leur labels
      AUDIT_FIELDS: [
        "modifierLe",
        "justificationTexte",
        "modifierParComplet",
        "nom",
        "prenom",
        "codeWindows",
        "domaineAfficher",
        "langueAfficher",
        "numeroEmploye",
        "statutAfficher",
        "dateDebutEmploi",
        "statut",
        "entiteAfficher",
        "siteOrigine",
        "codeProfilUtilisateur",
        "typeEmploiAfficher",
        "dateFinEmploi",
        "secteurAfficher",
        "sousSecteurAfficher",
        "nomGroupeSecurite",
        "autorite",
        "confidentialite",
        "commentaire",
        "gestionnaire",
        "justificationFichier"
      ],
      FIELD_LABELS: {
        "modifierLe": "Enregistrement en date du ",
        "justificationTexte": "Justification ",
        "modifierParComplet": "Par ",
        "nom": "Nom ",
        "prenom": "Prénom ",
        "codeWindows": "Code Windows ",
        "domaineAfficher": "Domaine ",
        "langueAfficher": "Lanque ",
        "numeroEmploye": "No. employé ",
        "statutAfficher": "Statut de l'emploi ",
        "dateDebutEmploi": "Date de début de l'emploi ",
        "statut": "Statut ",
        "entiteAfficher": "Entité ",
        "siteOrigine": "Site d'origine ",
        "codeProfilUtilisateur": "Code du profil ",
        "typeEmploiAfficher": "Type de l'emploi ",
        "dateFinEmploi": "Date de fin du type d'emploi ",
        "secteurAfficher": "Secteur ",
        "sousSecteurAfficher": "Sous-secteur ",
        "nomGroupeSecurite": "Groupe de sécurité ",
        "autorite": "Niveau d'autorité ",
        "confidentialite": "Confidentialité ",
        "commentaire": "Commentaire ",
        "gestionnaire": "Gestionnaire ",
        "justificationFichier": "Fichier(s) de justification"
      },
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      intervenant: "pilotage/intervenant",
    }),
    nombreModifications() {
      return this.auditsData.length;
    },
    tailleListeMultimedia() {
      return this.justificationFichier.length
    },
    listeMultimedia() {
      return this.justificationFichier
    },
  },
  methods: {
    formatterAudits(listeAudits) {
      let listeAuditsDetaille = []
      let listeAffichage = []
      let auditPrecedent = null

      listeAudits.forEach((audit) => {
        listeAuditsDetaille.push({
          "modifierLe": this.$commun.formatDateHeure(audit.justification.modifierLe),
          "justificationTexte": audit.justification.justificationText,
          "modifierParComplet": audit.intervenantCommunVO.modifierParComplet,
          "nom": audit.intervenantCommunVO.nom,
          "prenom": audit.intervenantCommunVO.prenom,
          "codeWindows": audit.intervenantCommunVO.codeWindows,
          "domaineAfficher": audit.intervenantCommunVO.domaineAfficher,
          "langueAfficher": audit.intervenantCommunVO.langueAfficher,
          "numeroEmploye": audit.intervenantCommunVO.numeroEmploye,
          "statutAfficher": audit.intervenantCommunVO.statutAfficher,
          "dateDebutEmploi": audit.intervenantCommunVO.dateDebutEmploi,
          "statut": audit.statut,
          "entiteAfficher": audit.entiteAfficher,
          "siteOrigine": audit.siteOrigine,
          "codeProfilUtilisateur": audit.codeProfilUtilisateur,
          "typeEmploiAfficher": audit.typeEmploiAfficher,
          "dateFinEmploi": audit.dateFinEmploi,
          "secteurAfficher": audit.secteurAfficher,
          "sousSecteurAfficher": audit.sousSecteurAfficher,
          "nomGroupeSecurite": audit.nomGroupeSecurite,
          "autorite": audit.autorite,
          "confidentialite": audit.confidentialite,
          "commentaire": audit.commentaire,
          "gestionnaire": audit.gestionnaire,
          "justificationFichier": audit.justification.justificationFichier
        });
        this.justificationFichier = audit.justification.justificationFichier;
      }),

          listeAuditsDetaille.forEach((audit) => {
            let auditAffichage = {}
            this.AUDIT_FIELDS.forEach(field => {
              if (field == "justificationFichier") {
                auditAffichage[field] = audit[field]
              }else {
                auditAffichage[field] = {texte: audit[field], isModifie: false,}
                if (auditPrecedent
                    && auditPrecedent[field].texte !== auditAffichage[field].texte
                    && !['modifierLe', 'justificationTexte', 'modifierParComplet'].includes(field)) {
                  auditAffichage[field].isModifie = true
                }
              }
            })

            auditPrecedent = auditAffichage

            listeAffichage.push(auditAffichage)

          })

      return listeAffichage
    },
    formatterAucunAudit() {
      let listeAudits = [];
      let audit = {
        "modifierLe": "",
        "justificationTexte": "",
        "modifierParComplet": "",
        "nom": this.intervenant.intervenantCommunVO.nom,
        "prenom": this.intervenant.intervenantCommunVO.prenom,
        "codeWindows": this.intervenant.intervenantCommunVO.codeWindows,
        "domaineAfficher": this.intervenant.intervenantCommunVO.domaineAfficher,
        "langueAfficher": this.intervenant.intervenantCommunVO.langueAfficher,
        "numeroEmploye": this.intervenant.intervenantCommunVO.numeroEmploye,
        "statutAfficher": this.intervenant.intervenantCommunVO.statutAfficher,
        "dateDebutEmploi": this.intervenant.intervenantCommunVO.dateDebutEmploi,
        "statut": this.intervenant.statut,
        "entiteAfficher": this.intervenant.entiteAfficher,
        "siteOrigine": this.intervenant.siteOrigine,
        "codeProfilUtilisateur": this.intervenant.codeProfilUtilisateur,
        "typeEmploiAfficher": this.intervenant.typeEmploiAfficher,
        "dateFinEmploi": this.intervenant.dateFinEmploi,
        "secteurAfficher": this.intervenant.secteurAfficher,
        "sousSecteurAfficher": this.intervenant.sousSecteurAfficher,
        "nomGroupeSecurite": this.intervenant.nomGroupeSecurite,
        "autorite": this.intervenant.autorite,
        "confidentialite": this.intervenant.confidentialite,
        "commentaire": this.intervenant.commentaire,
        "gestionnaire": this.intervenant.gestionnaire
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        auditAffichage[field] = {texte: audit[field], isModifie: false,}
      })

      listeAudits.push(auditAffichage);
      return listeAudits;
    },
    onSelect(event){
      var arr = event.donnees;
      const linkSource = `data:application/pdf;base64,${arr}`;
      const downloadLink = document.createElement("a");
      const fileName = event.description;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
  },
};
</script>